import { useState, useEffect, createRef } from 'react';
import { makeRequest } from '../utils';
import config from '../config';

export default function useCustomReport() {
  const [reportName, setReportName] = useState();
  const [reportData, setReportData] = useState([]);
  const [active, setActive] = useState(false);
  const reportLink = createRef();

  useEffect(() => {
    if (reportData.length) {
      setActive(true);
    }
  }, [reportData]);

  useEffect(() => {
    if (active) {
      reportLink.current.link.click();
      setActive(false);
    }
  }, [active, reportLink]);

  const handleCustomReport = (selectedReportName) => {
    setReportName(selectedReportName);
    const requestURL = config.customReports.requestURLs[selectedReportName];
    if (requestURL !== undefined) {
      makeRequest(requestURL)
        .then((data) => {
          setReportData(data);
        })
        .catch((error) => {
          console.error(`Error fetching API data from ${requestURL}: ` + error);
        });
    }
  };
  return [reportName, reportData, reportLink, handleCustomReport];
}
